import React, { Component } from 'react';
import { connect } from 'react-redux';
import {Link, Redirect } from 'react-router-dom';
import * as api from '../../apiUtils/api';
import * as taskActions from '../../redux/tasks/actions';
import WaitWithNote from '../common/WaitWithNote'

class TaskAcceptance extends Component {
    
    state = {
        redirect: false,
        error: null
    }

    componentDidMount(){
        this.props.taskSelected();
    }

    componentWillMount(){
    }

    cancelClick(){
        this.props.taskCancel();   
    }

    acceptClick(){
        this.props.setWaiting(true)
        this.props.acceptTask(this.props.auth.jwtToken,this.props.taskDist.task.task_dist_id)
    }

    resumeTaskClick(){
        const taskAcceptedInfo=this.props.taskDist.taskResumeInfo;
        this.props.taskAcceptResume(taskAcceptedInfo);
    }

    render(){
        const { taskDist } = this.props;
        const { redirect } = this.state;
        
        const backToProjectTasks=`/projectTasks/${taskDist.taskCategoryId}`
        
        if (this.props.taskDist.waiting){
            return <WaitWithNote waitNote={'Please wait...'} />
        }

        if (this.props.taskDist.taskAccepted){
            return <Redirect to='/taskRender'  />
        }

        let cardBody=null;
        
        if (this.props.taskDist.taskError || this.props.taskDist.taskCanResume){
            let cardTitle = 'You have already accepted a task'
            if (this.props.taskDist.taskError){
                cardTitle = this.props.taskDist.taskError
            }

            let renderResumeButton=this.props.taskDist.taskCanResume?(
              <div>
                <Link to={backToProjectTasks} >
                    <button type="button" className="btn btn-secondary">Back to Tasks list</button>
                </Link>    
                &nbsp;&nbsp;
                <button type="button" className="btn btn-primary" onClick={this.resumeTaskClick.bind(this)}>Resume</button>
              </div>
            ):(
            <Link to={backToProjectTasks} >
                <button type="button" className="btn btn-secondary">Back to Tasks list</button>
            </Link> 
            );
            cardBody=(
                <div className="card-body">
                    <h4 className="card-title">{cardTitle}</h4>
                    <p className="card-text"></p>
                    {renderResumeButton}
                </div>
            );
        }else {
            cardBody=this.props.taskDist.task?(
                <div className="card-body">
                    <h4 className="card-title">{this.props.taskDist.task.task_name}</h4>
                    <p className="card-text"></p>
                    <Link to={backToProjectTasks} >
                        <button type="button" className="btn btn-secondary">Cancel</button>
                    </Link>
                    &nbsp;&nbsp;
                    <button type="button" className="btn btn-primary" onClick={this.acceptClick.bind(this)}>Accept</button>
                </div>
                ):(
                    <div className="card-body">
                        <h4 className="card-title">No task selected!</h4>
                        <p className="card-text"></p>
                    </div>
                )
        }
        
        return (
            <div className='container'>
                <div className='row'>
                    <br />
                </div>    
                <div className='row'>
                    <div className='col-sm'>
                        <div className="card text-center">
                            <div className="card-header">
                                Task
                            </div>
                            {cardBody}
                            <div className="card-footer text-muted">
                            </div>    
                        </div>
                    </div>    
                </div>    
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
      auth: state.auth,
      taskDist: state.taskDist
    }
}

const mapDispatchToProps = (dispatch, ownProps) => {
    return {
      taskSelected: () => {
            dispatch(taskActions.taskSelected())
      },  
      taskCancel: () => {
        dispatch(taskActions.taskCancel())
      },
      taskAccept: (taskAcceptedInfo) => {
        dispatch(taskActions.taskAccept(taskAcceptedInfo))  
      },
      taskAcceptError: (error) => {
        dispatch(taskActions.taskAcceptError(error))    
      },
      taskCanResume: (taskAcceptedInfo) => {
        dispatch(taskActions.taskCanResume(taskAcceptedInfo))    
      },
      taskAcceptResume: (taskAcceptedInfo) => {
        dispatch(taskActions.taskAcceptResume(taskAcceptedInfo))   
      },
      acceptTask: (jwt,taskId) => {
        dispatch(taskActions.acceptTask(jwt,taskId))
      },
      checkResumeTaskInfo: (jwt,taskId) => {
        dispatch(taskActions.checkResumeTaskInfo(jwt,taskId)) 
      },
      setWaiting: (status:boolean)=> {
        dispatch(taskActions.setWaiting(status))
      }
    }
}
  
export default connect(mapStateToProps,mapDispatchToProps)(TaskAcceptance);


// WEBPACK FOOTER //
// ./src/views/TaskAcceptance/TaskAcceptance.js